__turbopack_context__.v({
  "apri": "MobileNavigation-module__3R97cq__apri",
  "chiudi": "MobileNavigation-module__3R97cq__chiudi",
  "pannello": "MobileNavigation-module__3R97cq__pannello",
  "piede": "MobileNavigation-module__3R97cq__piede",
  "testata": "MobileNavigation-module__3R97cq__testata",
  "titolo": "MobileNavigation-module__3R97cq__titolo",
  "tratti": "MobileNavigation-module__3R97cq__tratti",
  "velo": "MobileNavigation-module__3R97cq__velo",
  "voce": "MobileNavigation-module__3R97cq__voce",
  "voceAttiva": "MobileNavigation-module__3R97cq__voceAttiva",
  "voci": "MobileNavigation-module__3R97cq__voci",
});
